import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Avatar, CardHeader, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { green, red, yellow } from "@mui/material/colors";
import {
  Error as ErrorIcon,
  Verified as VerifiedIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { ReactNode } from "react";
import { AlertLevelStrings } from "../../../types/AlertLevelStrings";

export default function SectionTile({
  content,
  alertLevel,
  remarks,
  title,
}: {
  content: string | ReactNode;
  alertLevel: AlertLevelStrings;
  remarks: any[] | null;
  title: string;
}) {
  const alertTextColor = {
    ERROR: red[500],
    WARN: yellow[500],
    INFO: green[500],
  };

  const alertBgColor = {
    ERROR: red[50],
    WARN: yellow[50],
    INFO: green[50],
  };

  const alertIcon = {
    ERROR: <ErrorIcon />,
    WARN: <WarningIcon />,
    INFO: <VerifiedIcon />,
  };

  return (
    <Grid item xs={4}>
      <Card sx={{ maxWidth: 345, height: "100%" }}>
        <CardHeader
          avatar={
            <Avatar
              sx={{
                bgcolor: alertTextColor[alertLevel],
              }}
            >
              {alertIcon[alertLevel]}
            </Avatar>
          }
          title={title}
          subheader={
            remarks && remarks.length
              ? remarks.length === 1
                ? remarks[0].message
                : remarks.map((remark) => {
                    return <li key={remark.message}>{remark.message}</li>;
                  })
              : null
          }
          sx={{ backgroundColor: alertBgColor[alertLevel] }}
        />
        {content && (
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {content}
            </Typography>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
}
